<!-- eslint-disable vue/no-v-html -->
<template>
  <Modal name="global" :disableClose="disableClose" @close="closeModal">
    <div v-if="header">
      <h2 v-html="header" />
    </div>
    <div v-if="body" class="py-4 text-center" v-html="body" />

    <div v-if="buttons" class="flex items-center gap-2">
      <CButton v-for="button in buttons" v-bind="button" :key="button.key">
        {{ button.text }}
      </CButton>
    </div>

    <div v-if="!buttons" class="flex justify-between gap-2 pt-4">
      <CButton
        data-testid="modal-button-1"
        :color="button1color"
        :class="{ invisible: !button1 }"
        :icon="button1icon"
        @click="OnButton1"
      >
        {{ button1 }}
      </CButton>
      <CButton
        data-testid="modal-button-2"
        :color="button2color"
        :class="{ invisible: !button2 }"
        :icon="button2icon"
        @click="OnButton2"
      >
        {{ button2 }}
      </CButton>
    </div>
  </Modal>
</template>

<script>
export default {
  computed: {
    disableClose() {
      return Boolean(this.Content.disableClose);
    },
    buttons() {
      return this.$modal.context?.buttons;
    },
    Content() {
      return this.$modal.context || {};
    },
    header() {
      return this.Content.header;
    },
    body() {
      return this.Content.body;
    },
    button1() {
      return this.Content.button1label;
    },
    button1icon() {
      return this.Content.button1icon;
    },
    button1signal() {
      return this.Content.button1signal;
    },
    button1alert() {
      return this.Content.button1alert;
    },
    button1green() {
      return this.Content.button1green;
    },
    button1color() {
      if (this.button1alert) return 'alert';
      if (this.button1signal) return 'signal';
      if (this.button1green) return 'green';
      return undefined;
    },
    button2() {
      return this.Content.button2label;
    },
    button2icon() {
      return this.Content.button2icon;
    },
    button2signal() {
      return this.Content.button2signal;
    },
    button2alert() {
      return this.Content.button2alert;
    },
    button2green() {
      return this.Content.button2green;
    },
    button2color() {
      if (this.button2alert) return 'alert';
      if (this.button2signal) return 'signal';
      if (this.button2green) return 'green';
      return undefined;
    },
  },

  methods: {
    OnButton1: function () {
      const cb = this.Content.button1callback;
      if (cb) cb();
      this.$modal.close('global', { trigger: this.button1 });
    },
    OnButton2: function () {
      const cb = this.Content.button2callback;
      if (cb) cb();
      this.$modal.close('global', { trigger: this.button2 });
    },
    closeModal() {
      const cb = this.Content.closeCallback;
      if (cb) cb();
    },
  },
};
</script>
